import React, { useRef, useState, useEffect } from 'react'
import { useForm, Controller } from "react-hook-form";
import type { FieldErrors, Control, UseFormSetValue } from "react-hook-form";

import Error from "@/components/Form/Error"
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from 'ckeditor5-custom-build-deeds'

type EditorProps = {
	control: any
	setValue?: any
	errors?: FieldErrors
	name: string
	defaultValue?: string
}

const Editor = ({
	control,
	setValue,
	errors,
	name,
	defaultValue
}: EditorProps) => {

	return (
		<Controller 
			control={control} 
			name={name} 
			render={({ field: { onChange, onBlur, value, ref } }) => (
				<>
					<CKEditor
						editor={ ClassicEditor }
						data={value || defaultValue || ''}
						config={{
							toolbar: {
								shouldNotGroupWhenFull: true
							},
						}}
						onReady={ editor => {
							// Initialize with current value or defaultValue
							const initialValue = value || defaultValue || '';
							if (initialValue) {
								editor.setData(initialValue);
							}
						}}
						onChange={ ( event: any, editor: any ) => {
							const data = editor.getData();
							onChange(data); // Use react-hook-form's onChange
						}}
						onBlur={onBlur}
						onFocus={ ( event, editor ) => {
							// Optional: Additional focus handling
						}}
					/>
					<Error name={name} errors={errors}/>
					<br/>
				</>
			)} 
		/>
	)
}
export default Editor